import { render, staticRenderFns } from "./freespaceInfo.vue?vue&type=template&id=ea066506&scoped=true&"
import script from "./freespaceInfo.vue?vue&type=script&lang=js&"
export * from "./freespaceInfo.vue?vue&type=script&lang=js&"
import style0 from "./freespaceInfo.vue?vue&type=style&index=0&id=ea066506&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea066506",
  null
  
)

export default component.exports